import { useState } from 'react';
import TrialModal from '../../../components/feature/TrialModal';

export default function SeniorHighSection() {
  const [activeGrade, setActiveGrade] = useState('高一');
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);

  const coursesByGrade = {
    '高一': [
      {
        subject: '數學',
        title: '高一數學班',
        image: 'https://public.readdy.ai/ai/img_res/d7945df808ce4051c1b6fb84324f60a1.jpg',
        features: ['代數基礎', '幾何概念', '函數圖形', '數列級數'],
        description: '建立高中數學基礎，培養邏輯思維能力，為後續進階課程奠定穩固根基。',
        schedule: '週六 09:00-12:00',
        focus: '基礎建立'
      },
      {
        subject: '物理',
        title: '高一物理班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20first%20year%20students%20aged%2015-16%20learning%20basic%20physics%20with%20mechanics%20and%20motion%2C%20teenagers%20doing%20physics%20experiments%20with%20simple%20equipment%2C%20modern%20science%20classroom%2C%20bright%20clean%20background%2C%20educational%20laboratory%20atmosphere&width=400&height=300&seq=senior1-physics&orientation=landscape',
        features: ['力學基礎', '運動學', '牛頓定律', '能量概念'],
        description: '從基礎力學開始，建立物理概念與科學思維，培養實驗觀察能力。',
        schedule: '週六 14:00-17:00',
        focus: '概念建立'
      },
      {
        subject: '化學',
        title: '高一化學班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20first%20year%20students%20aged%2015-16%20learning%20basic%20chemistry%20with%20periodic%20table%20and%20simple%20experiments%2C%20teenagers%20in%20chemistry%20lab%20with%20safety%20equipment%2C%20modern%20laboratory%20classroom%2C%20bright%20clean%20background%2C%20scientific%20learning%20environment&width=400&height=300&seq=senior1-chemistry&orientation=landscape',
        features: ['原子結構', '化學鍵結', '化學反應', '實驗技能'],
        description: '學習化學基本原理，透過實驗操作加深理解，培養科學探究精神。',
        schedule: '週日 09:00-12:00',
        focus: '實驗操作'
      },
      {
        subject: '英文',
        title: '高一英文班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20first%20year%20students%20aged%2015-16%20in%20English%20strengthening%20class%2C%20teenagers%20studying%20advanced%20English%20materials%20with%20grammar%20books%2C%20classroom%20with%20modern%20equipment%2C%20bright%20clean%20background%2C%20focused%20learning%20environment&width=400&height=300&seq=senior1-english&orientation=landscape',
        features: ['高中文法', '字彙擴充', '閱讀策略', '寫作基礎'],
        description: '銜接國中課程，適應高中英文學習節奏，建立更高層次的語言能力基礎。',
        schedule: '週日 14:00-17:00',
        focus: '學力奠基'
      }
    ],
    '高二': [
      {
        subject: '數學',
        title: '高二數學班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20students%20aged%2016-17%20learning%20advanced%20mathematics%20with%20calculus%20and%20trigonometry%2C%20teenagers%20solving%20complex%20math%20problems%2C%20organized%20classroom%20with%20advanced%20mathematical%20concepts%2C%20bright%20clean%20background%2C%20intensive%20study%20atmosphere&width=400&height=300&seq=senior2-math&orientation=landscape',
        features: ['三角函數', '指對數', '微積分', '機率統計'],
        description: '深化數學概念，學習進階內容，為學測做好充分準備。',
        schedule: '週六 09:00-12:00',
        focus: '進階學習'
      },
      {
        subject: '化學',
        title: '高二化學班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20students%20aged%2016-17%20learning%20advanced%20chemistry%20with%20organic%20compounds%20and%20reactions%2C%20teenagers%20doing%20complex%20chemistry%20experiments%2C%20modern%20laboratory%20with%20advanced%20equipment%2C%20bright%20clean%20background%2C%20serious%20scientific%20atmosphere&width=400&height=300&seq=senior2-chemistry&orientation=landscape',
        features: ['有機化學', '化學平衡', '電化學', '化學動力學'],
        description: '學習進階化學概念，強化實驗技能，培養化學思維與解題能力。',
        schedule: '週六 14:00-17:00',
        focus: '概念深化'
      },
      {
        subject: '物理',
        title: '高二物理班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20students%20aged%2016-17%20learning%20advanced%20physics%20with%20electricity%20and%20magnetism%2C%20teenagers%20working%20with%20electrical%20circuits%20and%20magnetic%20fields%2C%20modern%20physics%20laboratory%2C%20bright%20clean%20background%2C%20focused%20experimental%20environment&width=400&height=300&seq=senior2-physics&orientation=landscape',
        features: ['電磁學', '波動光學', '熱力學', '近代物理'],
        description: '探索電磁現象與波動理論，建立完整的物理知識體系。',
        schedule: '週日 09:00-12:00',
        focus: '理論應用'
      },
      {
        subject: '英文',
        title: '高二英文班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20students%20aged%2016-17%20preparing%20for%20college%20entrance%20exams%2C%20teenagers%20working%20on%20practice%20tests%20and%20exam%20materials%2C%20serious%20academic%20atmosphere%20with%20English%20textbooks%2C%20bright%20clean%20background%2C%20test%20preparation%20setting&width=400&height=300&seq=senior2-english&orientation=landscape',
        features: ['學測題型', '時事英文', '進階寫作', '聽力強化'],
        description: '針對學科能力測驗設計，加強各項題型訓練，提升應試能力與答題技巧。',
        schedule: '週日 14:00-17:00',
        focus: '學測準備'
      }
    ],
    '高三': [
      {
        subject: '數學',
        title: '高三數學班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20students%20aged%2017-18%20in%20intensive%20mathematics%20exam%20preparation%2C%20teenagers%20solving%20advanced%20calculus%20and%20statistics%20problems%2C%20exam%20simulation%20environment%20with%20practice%20tests%2C%20bright%20clean%20background%2C%20concentrated%20study%20atmosphere&width=400&height=300&seq=senior3-math&orientation=landscape',
        features: ['學測衝刺', '模擬測驗', '弱點補強', '解題策略'],
        description: '最後衝刺階段的數學總複習，針對學測題型進行密集訓練與弱點補強。',
        schedule: '週六 09:00-12:00 + 週日 09:00-12:00',
        focus: '學測衝刺'
      },
      {
        subject: '化學',
        title: '高三化學班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20students%20aged%2017-18%20in%20intensive%20chemistry%20exam%20preparation%2C%20teenagers%20reviewing%20chemical%20equations%20and%20doing%20practice%20tests%2C%20exam%20preparation%20classroom%20with%20periodic%20table%2C%20bright%20clean%20background%2C%20serious%20exam%20atmosphere&width=400&height=300&seq=senior3-chemistry&orientation=landscape',
        features: ['總複習', '考題演練', '實驗重點', '答題技巧'],
        description: '化學科目總複習，整合三年所學，強化學測應試能力與實驗概念。',
        schedule: '週六 14:00-17:00 + 週日 14:00-17:00',
        focus: '總複習'
      },
      {
        subject: '物理',
        title: '高三物理班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20students%20aged%2017-18%20in%20intensive%20physics%20exam%20preparation%2C%20teenagers%20solving%20complex%20physics%20problems%20and%20reviewing%20formulas%2C%20exam%20simulation%20environment%20with%20physics%20equations%2C%20bright%20clean%20background%2C%20focused%20exam%20preparation&width=400&height=300&seq=senior3-physics&orientation=landscape',
        features: ['綜合複習', '題型分析', '公式整理', '計算技巧'],
        description: '物理科目全面複習，加強計算能力與概念理解，確保學測高分表現。',
        schedule: '週六 18:00-21:00',
        focus: '綜合複習'
      },
      {
        subject: '英文',
        title: '高三英文班',
        image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20students%20aged%2017-18%20in%20intensive%20English%20exam%20preparation%2C%20teenagers%20taking%20practice%20tests%20and%20writing%20essays%2C%20exam%20simulation%20environment%20with%20test%20papers%2C%20bright%20clean%20background%2C%20concentrated%20study%20atmosphere&width=400&height=300&seq=senior3-english&orientation=landscape',
        features: ['模擬測驗', '弱點補強', '答題策略', '心理調適'],
        description: '最後衝刺階段的密集訓練，針對個人弱點進行補強，確保在學測中發揮最佳實力。',
        schedule: '週日 18:00-21:00',
        focus: '學測衝刺'
      }
    ]
  };

  const courses = [
    {
      title: '高一數學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20first%20year%20mathematics%20class%20with%20students%20aged%2015-16%20learning%20advanced%20algebra%20and%20trigonometry%2C%20teenagers%20solving%20complex%20math%20problems%20on%20whiteboard%2C%20modern%20classroom%20with%20mathematical%20diagrams%20and%20formulas%2C%20bright%20clean%20white%20background%2C%20focused%20academic%20atmosphere%2C%20textbooks%20and%20calculators%20visible&width=400&height=300&seq=senior1-math-new&orientation=landscape',
      features: ['進階代數', '三角函數', '數列級數', '解析幾何'],
      description: '建立高中數學基礎，培養邏輯思維與解題能力，為學測做準備。',
      schedule: '星期六早上 09:00-12:00'
    },
    {
      title: '高一物理/化學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20first%20year%20physics%20and%20chemistry%20class%20with%20students%20aged%2015-16%20doing%20experiments%2C%20teenagers%20learning%20with%20lab%20equipment%20and%20scientific%20instruments%2C%20modern%20science%20laboratory%20classroom%2C%20bright%20clean%20white%20background%2C%20educational%20experimental%20atmosphere%2C%20safety%20equipment%20and%20chemicals%20visible&width=400&height=300&seq=senior1-sci-new&orientation=landscape',
      features: ['基礎物理', '化學原理', '實驗操作', '科學推理'],
      description: '物理化學基礎觀念建立，透過實驗培養科學素養與實驗技能。',
      schedule: '星期六下午 14:00-17:00'
    },
    {
      title: '高二數學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20mathematics%20class%20with%20students%20aged%2016-17%20learning%20calculus%20and%20advanced%20functions%2C%20teenagers%20solving%20complex%20mathematical%20problems%2C%20organized%20classroom%20with%20advanced%20math%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20academic%20atmosphere%2C%20mathematical%20formulas%20visible&width=400&height=300&seq=senior2-math-new&orientation=landscape',
      features: ['微積分基礎', '向量幾何', '機率統計', '複數'],
      description: '深化數學概念，學習微積分基礎，為學測數學科做完整準備。',
      schedule: '星期日早上 09:00-12:00'
    },
    {
      title: '高二物理/化學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20second%20year%20physics%20and%20chemistry%20class%20with%20students%20aged%2016-17%20doing%20advanced%20experiments%2C%20teenagers%20learning%20complex%20scientific%20concepts%20with%20sophisticated%20lab%20equipment%2C%20modern%20science%20classroom%2C%20bright%20clean%20white%20background%2C%20focused%20experimental%20learning%20atmosphere%2C%20advanced%20scientific%20instruments%20visible&width=400&height=300&seq=senior2-sci-new&orientation=landscape',
      features: ['進階物理', '有機化學', '實驗設計', '學測準備'],
      description: '進階物理化學概念，加強實驗操作與分析能力，學測科目重點複習。',
      schedule: '星期六早上 09:00-12:00'
    },
    {
      title: '高三數學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20mathematics%20intensive%20exam%20preparation%20with%20students%20aged%2017-18%2C%20teenagers%20solving%20advanced%20calculus%20and%20statistics%20problems%20for%20college%20entrance%20exam%2C%20organized%20classroom%20with%20test%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20exam%20preparation%20atmosphere%2C%20practice%20tests%20and%20formulas%20visible&width=400&height=300&seq=senior3-math-new&orientation=landscape',
      features: ['學測衝刺', '綜合題型', '解題速度', '考試技巧'],
      description: '學測數學科目衝刺，強化解題技巧，提升應試能力與信心。',
      schedule: '星期五晚上 18:00-21:00'
    },
    {
      title: '高三英文班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20English%20exam%20preparation%20with%20students%20aged%2017-18%2C%20teenagers%20practicing%20advanced%20reading%20comprehension%20and%20essay%20writing%20for%20college%20entrance%20exam%2C%20organized%20classroom%20with%20test%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20exam%20preparation%20atmosphere%2C%20practice%20papers%20and%20vocabulary%20books%20visible&width=400&height=300&seq=senior3-eng-new&orientation=landscape',
      features: ['學測準備', '閱讀測驗', '英文作文', '聽力訓練'],
      description: '學測英文科目準備，強化閱讀理解與寫作能力，提升應試技巧。',
      schedule: '週一至週五 19:00-21:00'
    },
    {
      title: '高三物理班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20physics%20exam%20preparation%20with%20students%20aged%2017-18%2C%20teenagers%20reviewing%20mechanics%20electricity%20and%20modern%20physics%20for%20college%20entrance%20exam%2C%20modern%20classroom%20with%20physics%20diagrams%2C%20bright%20clean%20white%20background%2C%20focused%20test%20preparation%20environment%2C%20physics%20formulas%20and%20practice%20problems%20visible&width=400&height=300&seq=senior3-phy-new&orientation=landscape',
      features: ['力學電磁', '近代物理', '學測衝刺', '解題技巧'],
      description: '學測物理科目準備，掌握重點觀念，熟練解題技巧與應試策略。',
      schedule: '週一至週五 19:00-21:00'
    },
    {
      title: '高三化學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20third%20year%20chemistry%20exam%20preparation%20with%20students%20aged%2017-18%2C%20teenagers%20reviewing%20organic%20and%20inorganic%20chemistry%20for%20college%20entrance%20exam%2C%20modern%20laboratory%20classroom%20with%20chemical%20formulas%2C%20bright%20clean%20white%20background%2C%20serious%20exam%20preparation%20atmosphere%2C%20chemistry%20equations%20and%20periodic%20table%20visible&width=400&height=300&seq=senior3-chem-new&orientation=landscape',
      features: ['有機無機', '化學計算', '學測準備', '實驗分析'],
      description: '學測化學科目準備，整合化學概念，強化計算與實驗分析能力。',
      schedule: '週一至週五 19:00-21:00'
    }
  ];

  const examTypes = [
    {
      exam: '學科能力測驗',
      description: '針對學測英文科目，提供完整的應試策略與技巧訓練',
      features: ['綜合測驗', '文意選填', '篇章結構', '閱讀測驗', '中譯英', '英文作文']
    },
    {
      exam: '全民英檢',
      description: '輔導學生考取中級、中高級、高級等各級檢定證書',
      features: ['聽力測驗', '閱讀能力', '寫作能力', '口說能力', '模擬測驗', '證書取得']
    },
    {
      exam: '多益測驗',
      description: '提升國際職場英語能力，為未來就業加分',
      features: ['商用英文', '聽力訓練', '閱讀理解', '文法應用', '字彙累積', '高分策略']
    }
  ];

  // 榮譽榜數據
  const [activeHonorTab, setActiveHonorTab] = useState('全校排名');

  const honorData = {
    '全校排名': [
      { name: '陳○豪', rank: '全校第1名' },
      { name: '李○萱', rank: '全校第2名' },
      { name: '王○宇', rank: '全校第3名' },
      { name: '張○涵', rank: '全校第5名' },
      { name: '林○軒', rank: '全校第7名' },
      { name: '黃○婷', rank: '全校第8名' },
      { name: '吳○翔', rank: '全校第10名' },
      { name: '劉○慧', rank: '全校第12名' },
      { name: '許○峰', rank: '全校第15名' },
      { name: '鄭○雯', rank: '全校第18名' }
    ],
    '班級排名': [
      { name: '陳○豪', rank: '全班第1名' },
      { name: '李○萱', rank: '全班第1名' },
      { name: '王○宇', rank: '全班第1名' },
      { name: '張○涵', rank: '全班第1名' },
      { name: '林○軒', rank: '全班第1名' },
      { name: '黃○婷', rank: '全班第2名' },
      { name: '吳○翔', rank: '全班第2名' },
      { name: '劉○慧', rank: '全班第2名' },
      { name: '許○峰', rank: '全班第3名' },
      { name: '鄭○雯', rank: '全班第3名' },
      { name: '周○傑', rank: '全班第3名' }
    ],
    '數學高分': [
      { name: '陳○豪', score: '98分' },
      { name: '李○萱', score: '97分' },
      { name: '王○宇', score: '96分' },
      { name: '張○涵', score: '95分' },
      { name: '林○軒', score: '94分' },
      { name: '黃○婷', score: '93分' },
      { name: '吳○翔', score: '92分' },
      { name: '劉○慧', score: '91分' },
      { name: '許○峰', score: '90分' },
      { name: '鄭○雯', score: '90分' }
    ],
    '英文高分': [
      { name: '李○萱', score: '99分' },
      { name: '陳○豪', score: '98分' },
      { name: '王○宇', score: '97分' },
      { name: '張○涵', score: '96分' },
      { name: '林○軒', score: '95分' },
      { name: '黃○婷', score: '94分' },
      { name: '吳○翔', score: '93分' },
      { name: '劉○慧', score: '92分' },
      { name: '許○峰', score: '91分' },
      { name: '鄭○雯', score: '90分' }
    ],
    '自然高分': [
      { name: '王○宇', score: '97分' },
      { name: '陳○豪', score: '96分' },
      { name: '李○萱', score: '95分' },
      { name: '張○涵', score: '94分' },
      { name: '林○軒', score: '93分' },
      { name: '黃○婷', score: '92分' },
      { name: '吳○翔', score: '91分' },
      { name: '劉○慧', score: '90分' },
      { name: '許○峰', score: '90分' },
      { name: '鄭○雯', score: '90分' }
    ]
  };

  const getHonorIcon = (tab: string) => {
    switch (tab) {
      case '全校排名': return 'ri-trophy-line';
      case '班級排名': return 'ri-medal-line';
      case '數學高分': return 'ri-calculator-line';
      case '英文高分': return 'ri-translate-2';
      case '自然高分': return 'ri-flask-line';
      default: return 'ri-star-line';
    }
  };

  const getHonorColor = (tab: string) => {
    switch (tab) {
      case '全校排名': return 'text-yellow-600 border-yellow-200 bg-yellow-50';
      case '班級排名': return 'text-purple-600 border-purple-200 bg-purple-50';
      case '數學高分': return 'text-blue-600 border-blue-200 bg-blue-50';
      case '英文高分': return 'text-green-600 border-green-200 bg-green-50';
      case '自然高分': return 'text-red-600 border-red-200 bg-red-50';
      default: return 'text-gray-600 border-gray-200 bg-gray-50';
    }
  };

  // 學生感謝信
  const testimonials = [
    {
      name: '陳○豪',
      content: '感謝威斯理的老師們，讓我在數學方面有了很大的進步。老師的教學方式很生動，讓原本困難的數學變得有趣多了！',
      rating: 5
    },
    {
      name: '李○萱',
      content: '在威斯理學習英文讓我受益良多，老師不只教文法，更注重實際應用。現在我對英文更有信心了！',
      rating: 5
    },
    {
      name: '王○宇',
      content: '物理一直是我的弱科，但在威斯理老師的指導下，我終於理解了許多概念。感謝老師的耐心教導！',
      rating: 5
    },
    {
      name: '張○涵',
      content: '化學實驗課程設計得很棒，讓我們能夠親手操作，加深對理論的理解。老師也很用心準備教材！',
      rating: 5
    },
    {
      name: '林○軒',
      content: '威斯理的學習環境很好，同學們都很認真，老師也很關心每個學生的學習狀況。真的很感謝！',
      rating: 5
    },
    {
      name: '黃○婷',
      content: '數學老師教學很有系統，從基礎開始建立，讓我對數學不再害怕。現在數學成績進步了很多！',
      rating: 5
    },
    {
      name: '吳○翔',
      content: '英文寫作一直是我的困擾，但老師教了很多實用的技巧，現在寫作文不再是難事了！',
      rating: 5
    },
    {
      name: '劉○慧',
      content: '物理老師會用生活中的例子來解釋抽象的概念，讓我們更容易理解。上課氣氛也很活潑！',
      rating: 5
    },
    {
      name: '許○峰',
      content: '化學課程安排得很完整，從基礎到進階都有涵蓋。老師也會針對學測重點加強訓練！',
      rating: 5
    },
    {
      name: '鄭○雯',
      content: '在威斯理學習讓我找到了讀書的方法，老師不只教知識，更教我們如何有效學習！',
      rating: 5
    },
    {
      name: '周○傑',
      content: '數學從不及格到現在能考90分以上，真的要感謝威斯理老師的用心教導和不放棄的精神！',
      rating: 5
    },
    {
      name: '蔡○琳',
      content: '英文聽力一直是我的弱項，但老師設計了很多練習活動，現在聽力進步了很多！',
      rating: 5
    },
    {
      name: '謝○宏',
      content: '物理實驗課讓我對科學產生了濃厚的興趣，老師總是鼓勵我們多思考、多提問！',
      rating: 5
    },
    {
      name: '楊○慈',
      content: '化學老師會耐心解答我們的每個問題，讓我們在輕鬆的環境中學習複雜的化學概念！',
      rating: 5
    },
    {
      name: '賴○志',
      content: '威斯理的課程規劃很完善，讓我們能夠循序漸進地學習。老師們都很專業且負責任！',
      rating: 5
    }
  ];

  return (
    <>
      <section id="senior-high" className="py-20 bg-green-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">高中部課程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              專為高中生設計的升學導向課程，結合學測準備與英語能力檢定，
              助學生在升學路上更具競爭優勢。
            </p>
          </div>

          {/* 年級標籤切換 */}
          <div className="flex justify-center mb-12">
            <div className="bg-white rounded-full p-2 shadow-lg">
              {Object.keys(coursesByGrade).map((grade) => (
                <button
                  key={grade}
                  onClick={() => setActiveGrade(grade)}
                  className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeGrade === grade
                      ? 'bg-green-600 text-white shadow-md'
                      : 'text-gray-600 hover:text-green-600'
                  }`}
                >
                  {grade}
                </button>
              ))}
            </div>
          </div>

          {/* 課程卡片 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            {coursesByGrade[activeGrade as keyof typeof coursesByGrade].map((course, index) => (
              <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={course.image}
                  alt={course.title}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-2xl font-bold text-gray-800">{course.title}</h3>
                    <div className="text-right">
                      <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium block mb-1">
                        {course.subject}
                      </span>
                      <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs">
                        {course.focus}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">{course.description}</p>
                  <div className="mb-4">
                    <div className="flex items-center text-gray-700 mb-2">
                      <i className="ri-time-line text-green-500 mr-2"></i>
                      <span className="text-sm">{course.schedule}</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 mb-6">
                    {course.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <button 
                    onClick={() => setIsTrialModalOpen(true)}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    預約試聽
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">檢定考試輔導</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {examTypes.map((exam, index) => (
                <div key={index} className="bg-white rounded-lg p-6 shadow-lg">
                  <h4 className="text-xl font-bold text-gray-800 mb-3">{exam.exam}</h4>
                  <p className="text-gray-600 mb-4">{exam.description}</p>
                  <div className="space-y-2">
                    {exam.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <i className="ri-arrow-right-line text-green-500 mr-2"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 升學成果表現 */}
          <div className="bg-white rounded-lg p-8 shadow-lg mb-16">
            <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">升學成果表現</h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">88%</div>
                <div className="text-sm text-gray-600">學測頂標以上</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">95%</div>
                <div className="text-sm text-gray-600">進入理想科系</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">750+</div>
                <div className="text-sm text-gray-600">多益平均分數</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">85%</div>
                <div className="text-sm text-gray-600">英檢中高級通過</div>
              </div>
            </div>
          </div>

          {/* 榮譽榜單 */}
          <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-8 shadow-lg mb-16">
            <div className="text-center mb-8">
              <i className="ri-trophy-line text-4xl text-yellow-500 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">榮譽榜單</h3>
              <p className="text-gray-600">威斯理學子優異表現</p>
            </div>

            {/* 榮譽標籤切換 */}
            <div className="flex flex-wrap justify-center gap-2 mb-8">
              {Object.keys(honorData).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveHonorTab(tab)}
                  className={`flex items-center px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap border-2 ${
                    activeHonorTab === tab
                      ? getHonorColor(tab)
                      : 'text-gray-600 border-gray-200 bg-white hover:bg-gray-50'
                  }`}
                >
                  <i className={`${getHonorIcon(tab)} mr-2`}></i>
                  {tab}
                </button>
              ))}
            </div>

            {/* 榮譽榜內容 */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {honorData[activeHonorTab as keyof typeof honorData].map((student, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-md text-center">
                  <div className="text-2xl font-bold text-yellow-600 mb-1">#{index + 1}</div>
                  <div className="font-semibold text-gray-800 mb-1">{student.name}</div>
                  <div className="text-sm font-medium text-purple-600">
                    {'rank' in student ? student.rank : `${student.score}`}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 學生感謝信 */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">學生感謝信</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-purple-500">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400 mr-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill"></i>
                      ))}
                    </div>
                    <div className="text-sm text-gray-500">
                      {testimonial.name}
                    </div>
                  </div>
                  <div className="relative">
                    <i className="ri-double-quotes-l text-2xl text-purple-300 absolute -top-2 -left-2"></i>
                    <p className="text-gray-700 leading-relaxed pl-6 pr-6">
                      {testimonial.content}
                    </p>
                    <i className="ri-double-quotes-r text-2xl text-purple-300 absolute -bottom-2 -right-2"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gradient-to-r from-green-100 to-blue-100 rounded-lg p-6">
              <h4 className="text-xl font-bold text-gray-800 mb-4">為什麼選擇威斯理高中部？</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <i className="ri-trophy-line text-3xl text-green-600 mb-2"></i>
                  <h5 className="font-semibold mb-1">升學實績優異</h5>
                  <p className="text-sm text-gray-600">連續5年學測表現超越全國平均</p>
                </div>
                <div className="text-center">
                  <i className="ri-team-line text-3xl text-green-600 mb-2"></i>
                  <h5 className="font-semibold mb-1">師資陣容堅強</h5>
                  <p className="text-sm text-gray-600">資深教師團隊，豐富升學輔導經驗</p>
                </div>
                <div className="text-center">
                  <i className="ri-focus-3-line text-3xl text-green-600 mb-2"></i>
                  <h5 className="font-semibold mb-1">個別化輔導</h5>
                  <p className="text-sm text-gray-600">針對學生程度調整教學策略</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrialModal isOpen={isTrialModalOpen} onClose={() => setIsTrialModalOpen(false)} />
    </>
  );
}
